import { ToolType, ToolDef } from '../types';

export const TOOLS: ToolDef[] = [
  // Wood tools
  { id: ToolType.WOOD_PICKAXE, name: 'Wooden Pickaxe', type: 'pickaxe', tier: 'wood', miningSpeed: 2, durability: 59, attackDamage: 2 },
  { id: ToolType.WOOD_AXE, name: 'Wooden Axe', type: 'axe', tier: 'wood', miningSpeed: 2, durability: 59, attackDamage: 3 },
  { id: ToolType.WOOD_SHOVEL, name: 'Wooden Shovel', type: 'shovel', tier: 'wood', miningSpeed: 2, durability: 59, attackDamage: 1 },
  { id: ToolType.WOOD_SWORD, name: 'Wooden Sword', type: 'sword', tier: 'wood', miningSpeed: 1, durability: 59, attackDamage: 4 },
  // Stone tools
  { id: ToolType.STONE_PICKAXE, name: 'Stone Pickaxe', type: 'pickaxe', tier: 'stone', miningSpeed: 4, durability: 131, attackDamage: 3 },
  { id: ToolType.STONE_AXE, name: 'Stone Axe', type: 'axe', tier: 'stone', miningSpeed: 4, durability: 131, attackDamage: 4 },
  { id: ToolType.STONE_SHOVEL, name: 'Stone Shovel', type: 'shovel', tier: 'stone', miningSpeed: 4, durability: 131, attackDamage: 2 },
  { id: ToolType.STONE_SWORD, name: 'Stone Sword', type: 'sword', tier: 'stone', miningSpeed: 1, durability: 131, attackDamage: 5 },
  // Iron tools
  { id: ToolType.IRON_PICKAXE, name: 'Iron Pickaxe', type: 'pickaxe', tier: 'iron', miningSpeed: 6, durability: 250, attackDamage: 4 },
  { id: ToolType.IRON_AXE, name: 'Iron Axe', type: 'axe', tier: 'iron', miningSpeed: 6, durability: 250, attackDamage: 5 },
  { id: ToolType.IRON_SHOVEL, name: 'Iron Shovel', type: 'shovel', tier: 'iron', miningSpeed: 6, durability: 250, attackDamage: 3 },
  { id: ToolType.IRON_SWORD, name: 'Iron Sword', type: 'sword', tier: 'iron', miningSpeed: 1, durability: 250, attackDamage: 6 },
  // Diamond tools
  { id: ToolType.DIAMOND_PICKAXE, name: 'Diamond Pickaxe', type: 'pickaxe', tier: 'diamond', miningSpeed: 8, durability: 1561, attackDamage: 5 },
  { id: ToolType.DIAMOND_AXE, name: 'Diamond Axe', type: 'axe', tier: 'diamond', miningSpeed: 8, durability: 1561, attackDamage: 6 },
  { id: ToolType.DIAMOND_SHOVEL, name: 'Diamond Shovel', type: 'shovel', tier: 'diamond', miningSpeed: 8, durability: 1561, attackDamage: 4 },
  { id: ToolType.DIAMOND_SWORD, name: 'Diamond Sword', type: 'sword', tier: 'diamond', miningSpeed: 1, durability: 1561, attackDamage: 7 },
];

const toolMap = new Map<ToolType, ToolDef>();
for (const tool of TOOLS) {
  toolMap.set(tool.id, tool);
}

export function getTool(id: ToolType): ToolDef | undefined {
  return toolMap.get(id);
}

export function getToolName(id: ToolType): string {
  return toolMap.get(id)?.name ?? 'Unknown';
}

export function getMiningSpeed(toolId: ToolType | undefined, blockToolType: string | undefined): number {
  if (!toolId) return 1;
  const tool = toolMap.get(toolId);
  if (!tool) return 1;
  if (tool.type === blockToolType) return tool.miningSpeed;
  return 1;
}

// Tool color for rendering in inventory
const TIER_COLORS: Record<string, string> = {
  wood: '#8B6914',
  stone: '#888',
  iron: '#ddd',
  diamond: '#55ffdd',
};

const TYPE_SYMBOLS: Record<string, string> = {
  pickaxe: '\u26CF', // pick
  axe: '\u{1FA93}', // axe
  shovel: '\u{1F9F9}', // broom (closest)
  sword: '\u2694', // swords
};

export function getToolColor(id: ToolType): string {
  const tool = toolMap.get(id);
  return tool ? (TIER_COLORS[tool.tier] ?? '#fff') : '#fff';
}

export function getToolSymbol(id: ToolType): string {
  const tool = toolMap.get(id);
  return tool ? (TYPE_SYMBOLS[tool.type] ?? '?') : '?';
}
